import React, { useState } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import styles from './manager.module.css';
import back from '../../assets/icons/back.svg';
import InsertBar from '../../components/InsertBar';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { Box, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";

function PositionAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [position_name, setPositionName] = useState("");
  const [position_name_short, setPositionNameShort] = useState("");
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handlePrevious = () => {
    if (position_name.trim() || position_name_short.trim()) {
      setShowCancelModal(true); 
    } else {
      navigate('/positionManager');
    }
  };

  const confirmCancelChanges = () => {
    setShowCancelModal(false);
    navigate('/positionManager'); 
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleUpdate = async () => {
    if (!position_name.trim() || !position_name_short.trim()) {
      handleError("กรุณากรอกข้อมูลให้ครบถ้วน");
      return;
    }
    setShowUpdateModal(true);
  };

  const confirmedUpdate = async () => {
    setLoading(true);
    const res = await api.newPosition(position_name.trim(),position_name_short.trim());
    setLoading(false);
  
    if (res) {
      if (res['data']['code'] === 200) {
        setShowUpdateModal(false); 
        navigate('/positionManager'); 
        
      } else {
        handleError(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };

  const handleCloseModal = () => {
    setShowUpdateModal(false);
  };

  const handleCloseErrorModal = () => setErrorMessage(null);
  const handleCloseCancelModal = () => setShowCancelModal(false);

  return (
    <>
      <Loader loading={loading} />
      {showUpdateModal && (
        <CustomizedModal
          onClose={handleCloseModal}
          apiCall={confirmedUpdate}
          confirmMessage={`ยืนยันที่จะเพิ่มข้อมูล`}
          confirmButtonText={`ยืนยัน`}
        />
      )}
      {errorMessage && (
        <CustomizedModal
          onClose={handleCloseErrorModal}
          confirmMessage={errorMessage}
          apiCall={handleCloseErrorModal} // No action required, just closes
          confirmButtonText={`ตกลง`}
        />
      )}
      {showCancelModal && (
        <CustomizedModal
          onClose={handleCloseCancelModal}
          apiCall={confirmCancelChanges}
          confirmMessage={`ยกเลิกการเปลี่ยนแปลง?`}
          confirmButtonText={`ตกลง`}

        />
      )}
      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการยศ
      </Box>
      <Box className={styles.head1Text}>เพิ่มข้อมูลยศ</Box>
      <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
        <Box className={styles.head2Text}>ชื่อยศ</Box>
        <InsertBar
          currentValue={position_name}
          setNewValue={setPositionName}
          placeholder="ชื่อยศ"
        />
        <Box className={styles.head2Text} sx={{marginTop: 1}}>ตัวย่อ</Box>
        <InsertBar
          currentValue={position_name_short}
          setNewValue={setPositionNameShort}
          placeholder="ตัวย่อ"
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 , marginRight: 4.3}}>
        <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            sx={{ padding: 1, borderRadius: 1.5 }}
        >
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
        </Button>
      </Box>
    </>
  );
}

export default PositionAdd;
